import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import { ASSET_WRITE, hasPrivilege } from 'utils/privileges';
import EditorPageHeader, { StickyEditorPageHeaderWrapper } from 'components/EditorPageHeader';
import FixedHeightTab from 'components/Tab/FixedHeightTab';
import Icon from 'components/Icon';
import AssetHeaderSubtitle from './AssetHeaderSubtitle';
import AssetHeaderOptionsMenu from './AssetHeaderOptionsMenu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SingleAssetHeader(_ref) {
  var wrapperRef = _ref.wrapperRef,
    _ref$isCollapsed = _ref.isCollapsed,
    isCollapsed = _ref$isCollapsed === void 0 ? false : _ref$isCollapsed,
    hasOpenOption = _ref.hasOpenOption,
    titleId = _ref.titleId,
    parentPlaylistId = _ref.parentPlaylistId,
    asset = _ref.asset,
    shareData = _ref.shareData,
    tabLinks = _ref.tabLinks,
    onClose = _ref.onClose,
    _ref$isBlockedByPlayl = _ref.isBlockedByPlaylistChanges,
    isBlockedByPlaylistChanges = _ref$isBlockedByPlayl === void 0 ? false : _ref$isBlockedByPlayl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var assetId = asset.id;
  var isAssetAdmin = hasPrivilege(ASSET_WRITE);
  var isEventAsset = asset.type === 'event';
  var detailsTab = tabLinks.details;
  var shareTab = tabLinks.share;
  var analyticsTab = tabLinks.analytics;
  var sessionsTab = tabLinks.sessions;
  function renderTab(_ref2) {
    var tab = _ref2.tab,
      icon = _ref2.icon,
      label = _ref2.label,
      isDisabled = _ref2.isDisabled;
    if (isCollapsed || !tab) {
      return null;
    }
    return /*#__PURE__*/_jsxs(FixedHeightTab, {
      isActive: tab.isActive,
      as: Link,
      to: generatePath(tab.link, {
        assetId: assetId
      }),
      "aria-current": tab.isActive ? 'page' : undefined,
      isDisabled: isDisabled,
      children: [/*#__PURE__*/_jsx(Icon, {
        name: icon,
        mr: "xs"
      }), label]
    });
  }
  return /*#__PURE__*/_jsx(StickyEditorPageHeaderWrapper, {
    children: /*#__PURE__*/_jsxs(EditorPageHeader, {
      wrapperRef: wrapperRef,
      title: asset.name,
      titleId: titleId,
      navMenu: /*#__PURE__*/_jsx(AssetHeaderOptionsMenu, {
        hasOpenOption: hasOpenOption,
        asset: asset,
        parentPlaylistId: parentPlaylistId,
        shareData: shareData,
        isBlockedByPlaylistChanges: isBlockedByPlaylistChanges
      }),
      subtitle: isCollapsed ? undefined : /*#__PURE__*/_jsx(AssetHeaderSubtitle, {
        asset: asset
      }),
      onClose: onClose,
      cardVariant: "raised",
      children: [renderTab({
        tab: detailsTab,
        icon: 'asset-image',
        label: t('panel_tab_details'),
        isDisabled: asset === undefined
      }), isAssetAdmin && renderTab({
        tab: shareTab,
        icon: 'send',
        label: t('panel_tab_share_and_nudge')
      }), isAssetAdmin && !isEventAsset && renderTab({
        tab: analyticsTab,
        icon: 'trending',
        label: t('panel_tab_analytics')
      }), isAssetAdmin && isEventAsset && renderTab({
        tab: sessionsTab,
        icon: 'asset-event',
        label: t('panel_tab_sessions')
      })]
    })
  });
}
export default SingleAssetHeader;